import * as Slider from "@radix-ui/react-slider";

interface Props {
  label: string;
  min: number;
  max: number;
  value: [number, number];
  onChange: (value: [number, number]) => void;
}

export default function RangeSelector({
  label,
  min,
  max,
  value,
  onChange,
}: Props) {
  return (
    <div className="flex flex-col gap-2 w-full">
      <label className="text-sm font-medium">{label}</label>

      <Slider.Root
        className="relative flex items-center w-full h-8 touch-none select-none"
        min={min}
        max={max}
        step={0.5}
        value={value}
        onValueChange={(v) => onChange([v[0], v[1]])}
      >
        <Slider.Track className="bg-gray-300 relative grow rounded-full h-1">
          <Slider.Range className="absolute bg-blue-500 rounded-full h-full transition-all duration-150" />
        </Slider.Track>

        {/* Thumb 1 */}
        <Slider.Thumb
          className="
            block w-5 h-5 bg-white shadow 
            rounded-full border border-gray-300 
            transition-transform duration-150 
            hover:scale-110 active:scale-125
          "
        />

        {/* Thumb 2 */}
        <Slider.Thumb
          className="
            block w-5 h-5 bg-white shadow 
            rounded-full border border-gray-300 
            transition-transform duration-150 
            hover:scale-110 active:scale-125
          "
        />
      </Slider.Root>

      <div className="text-xs text-gray-600 flex justify-between">
        <span>{value[0]}</span>
        <span>{value[1]}</span>
      </div>
    </div>
  );
}
